import { render, staticRenderFns } from "./ReferralProgram.vue?vue&type=template&id=5489f9da&scoped=true&"
import script from "./ReferralProgram.vue?vue&type=script&lang=js&"
export * from "./ReferralProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489f9da",
  null
  
)

export default component.exports